<template>

	<div class="">

		<nav aria-label="Progress" class="mx-auto w-fit">
			<h2 class="text-2xl font-googleBold text-gray-900 pb-6">Repository Setup</h2>
			<ol role="list" class="overflow-hidden">
				<li class="relative pb-10">
					<div class="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full" aria-hidden="true"
						 :class="[authComplete ? 'bg-indigo-600' : 'bg-gray-300']"	></div>
					<!-- Complete Step -->
					<div class="relative flex items-start group">
						<span class="h-9 flex items-center">

							<!-- current step -->
							<span v-if="!authComplete" class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-indigo-600 rounded-full">
								<span class="h-2.5 w-2.5 bg-indigo-600 rounded-full"></span>
							</span>

							<!-- completed step -->
							<span v-else class="relative z-10 w-8 h-8 flex items-center justify-center bg-indigo-600 rounded-full group-hover:bg-indigo-800">
								<!-- Heroicon name: solid/check -->
								<svg class="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
									<path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
								</svg>
							</span>

						</span>
						<span class="ml-4 min-w-0 flex flex-col">
							<span class="text-xs font-semibold tracking-wide uppercase" :class="[!authComplete ? 'text-indigo-600' : '']">Authenticate with Google</span>
							<span class="text-sm text-gray-500">Authentication allows SlideCub to copy and generation presentations.</span>
							<span v-if="!authValid" class="text-sm text-red-500 mt-3">Your previous authentication expired. Please re-authenticate.</span>
						</span>
					</div>

					<div v-if="!authComplete" class="flex items-center mt-6 ml-12">


						<a href="/start-google-auth" type="button" class="gsi-material-button">
							<div class="gsi-material-button-state"></div>
							<div class="gsi-material-button-content-wrapper">
								<div class="gsi-material-button-icon">
									<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
										<path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
										<path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
										<path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
										<path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
										<path fill="none" d="M0 0h48v48H0z"></path>
									</svg>
								</div>
								<span class="gsi-material-button-contents">Continue with Google</span>
								<span style="display: none;">Continue with Google</span>
							</div>
						</a>





<!--						<a href="/start-google-auth" type="button" class="border border-gray-400 bg-white font-google text-gray-700 hover:bg-opacity-10 focus:ring-4 focus:outline-none focus:ring-[#4285F4]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center mr-2">-->
<!--							&lt;!&ndash;				<svg class="mr-2 -ml-1 w-4 h-4" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="google" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512"><path fill="currentColor" d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"></path></svg>&ndash;&gt;-->
<!--							<svg class="mr-2 -ml-1" width="24" height="24" xmlns="http://www.w3.org/2000/svg">-->
<!--								<path fill="#4285F4" d="M23.745 12.27c0-.79-.07-1.54-.19-2.27h-11.3v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82Z"/>-->
<!--								<path fill="#34A853" d="M12.255 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96h-3.98v3.09C3.515 21.3 7.565 24 12.255 24Z"/>-->
<!--								<path fill="#FBBC05" d="M5.525 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62h-3.98C.725 8.24.255 10.06.255 12s.47 3.76 1.29 5.38l3.98-3.09Z"/>-->
<!--								<path fill="#EA4335" d="M12.255 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C18.205 1.19 15.495 0 12.255 0c-4.69 0-8.74 2.7-10.71 6.62l3.98 3.09c.95-2.85 3.6-4.96 6.73-4.96Z"/>-->
<!--							</svg>-->
<!--							<span class="whitespace-nowrap">Authenticate with Google</span>-->
<!--						</a>-->
						<div class="text-xs italic pl-4">You will be redirected to Google, and returned here once complete. See Q&A for permissions requested.</div>
					</div>
				</li>

				<!-- step 2 -->
				<li class="relative pb-10">
					<div class="-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full" aria-hidden="true"
						 :class="[authComplete && bookmarkletComplete ? 'bg-indigo-600' : 'bg-gray-300']"></div>

					<a href="#" class="relative flex items-start group" aria-current="step">
						<span class="h-9 flex items-center" aria-hidden="true">

							<!-- upcoming step -->
							<span v-if="!authComplete" class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full group-hover:border-gray-400">
								<span class="h-2.5 w-2.5 bg-transparent rounded-full group-hover:bg-gray-300"></span>
							</span>

							<!-- current step -->
							<span v-else-if="authComplete && !bookmarkletComplete" class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-indigo-600 rounded-full">
								<span class="h-2.5 w-2.5 bg-indigo-600 rounded-full"></span>
							</span>

							<!-- completed step -->
							<span v-else class="relative z-10 w-8 h-8 flex items-center justify-center bg-indigo-600 rounded-full group-hover:bg-indigo-800">
								<!-- Heroicon name: solid/check -->
								<svg class="w-5 h-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
									<path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
								</svg>
							</span>


						</span>
						<span class="ml-4 min-w-0 flex flex-col">
							<span class="text-xs font-semibold tracking-wide uppercase" :class="[authComplete && !bookmarkletComplete ? 'text-indigo-600' : '']">Setup Bookmarklet</span>
							<span class="text-sm text-gray-500">Add a bookmark that allows you to save any Google Slide with one click.</span>
						</span>
					</a>

					<div v-if="authComplete" class="flex items-center mt-6 ml-12">
						<a :href="customURL" @focus="focusBookmarklet()" class="border border-gray-400 bg-white font-google text-gray-700 hover:bg-opacity-80 focus:ring-4 focus:outline-none focus:ring-[#4285F4]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center mr-2 mb-2">
							<svg class="mr-2 -ml-1" width="24px" height="24px" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor"><path d="M5 21V5a2 2 0 012-2h10a2 2 0 012 2v16l-5.918-3.805a2 2 0 00-2.164 0L5 21z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
							Save Slide Bookmark
						</a>
						<div class="text-xs italic">Drag and drop into your browser bar, or bookmark this link.</div>
					</div>


				</li>

				<li class="relative">
					<!-- Upcoming Step -->
					<a href="#" class="relative flex items-start group">
						<span class="h-9 flex items-center" aria-hidden="true">

							<!-- current step -->
							<span v-if="authComplete && bookmarkletComplete" class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-indigo-600 rounded-full">
								<span class="h-2.5 w-2.5 bg-indigo-600 rounded-full"></span>
							</span>

							<!-- upcoming step -->
							<span v-else class="relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full group-hover:border-gray-400">
								<span class="h-2.5 w-2.5 bg-transparent rounded-full group-hover:bg-gray-300"></span>
							</span>

						</span>
						<span class="ml-4 min-w-0 flex flex-col">
							<span class="text-xs font-semibold tracking-wide uppercase" :class="[authComplete && bookmarkletComplete ? 'text-indigo-600' : 'text-gray-500']">Save your first slide</span>
							<span class="text-sm text-gray-500">Access any Google Slide, click the bookmark, and return to SlideCub to preview and save.</span>
						</span>
					</a>

					<div v-if="props.pendingSlideCount > 0" class="flex items-center mt-6 ml-12">
						<a href="#" @click="$emit('openProcessPending')" class="border border-gray-400 text-white bg-indigo-700 font-google hover:bg-opacity-90 focus:ring-4 focus:outline-none focus:ring-[#4285F4]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center mr-2 mb-2">
							Process Pending Slides
							<svg aria-hidden="true" width="11" height="10" fill="none" class="ml-1.5 flex-none text-gray-400 group-hover:text-indigo-700">
								<path d="M5.593 9.638L10.232 5 5.593.36l-.895.89 3.107 3.103H0v1.292h7.805L4.698 8.754l.895.884z" fill="currentColor"></path>
							</svg>
						</a>
						<div class="text-xs italic">Click to process and save your first slide!</div>
					</div>
				</li>

			</ol>
		</nav>





	</div>



</template>

<script setup>

import {onMounted, ref} from "vue";

const props = defineProps({
	pendingSlideCount: Number,
	auth: Object,
})
const authComplete = ref(false);
const authValid = ref(false);
const bookmarkletComplete = ref(false);


const customURL = "javascript:(function()%7Bvar%20e%20%3D%20%22" + encodeURIComponent(window.location.origin) + "%2Fapi%2Fslide-process%3Fauth%3D" + props.auth.user.uuid + "%22%20%2B%20%22%26slide%3D%22%20%2B%20document.location.hash.slice(1)%20%2B%20%22%26url%3D%22%20%2B%20document.location.href%3Bvar%20xhr%20%3D%20new%20XMLHttpRequest()%3Bxhr.onreadystatechange%20%3D%20function()%20%7Bif%20(this.readyState%20%3D%3D%3D%204%20%26%26%20this.responseText.length%20%3E%200)%20%7BNotification.requestPermission((result)%20%3D%3E%20%7Bif%20(result%20%3D%3D%3D%20'denied')%20%7Balert('Enable%20notifications%20for%20passive%20alerts%20when%20you%20save%20a%20slide.')%3B%7D%20else%20%7Bnew%20Notification(this.responseText)%3Bconsole.log(this.response)%3B%7D%7D)%3B%7D%7D%3Bxhr.open(%22POST%22%2C%20encodeURI(e))%3Bxhr.send()%7D)()"

// WORKING
// const customURL = "javascript:(function()%7B!function()%7B%0A%20%20%20%20var%20e%20%3D%20%22" + encodeURIComponent(window.location.origin) + "%2Fapi%2Ftest%3Fauth%3D" + props.auth.user.uuid + "%22%20%2B%20%22%26slide%3D%22%20%2B%20document.location.hash.slice(1)%20%2B%20%22%26url%3D%22%20%2B%20document.location.href%3B%0A%20%20%20%20xhr%20%3D%20new%20XMLHttpRequest()%3B%0A%20%20%20%20xhr.onreadystatechange%20%3D%20function()%20%7B%0A%20%20%20%20%20%20%20%20if%20(xhr.readyState%20%3D%3D%204%20%26%26%20xhr.responseText.length%20%3E%200)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20alert(xhr.responseText)%3B%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%7D%0A%20%20%20%20xhr.open(%22POST%22%2C%20encodeURI(e))%3B%20%0A%20%20%20%20xhr.send()%3B%0A%7D()%3B%7D)()%3B"

onMounted(() => {
	if(props.auth.user.hasGAuth && props.auth.user.isGAuthValid) authComplete.value = true;
	if(props.auth.user) authValid.value = props.auth.user.isGAuthValid;
	if(props.pendingSlideCount > 0) bookmarkletComplete.value = true;
});

function focusBookmarklet() {
	setTimeout(function() { bookmarkletComplete.value = true; }, 2000);
}

</script>

<style scoped>
.gsi-material-button {
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	-webkit-appearance: none;
	background-color: WHITE;
	background-image: none;
	border: 1px solid #747775;
	-webkit-border-radius: 20px;
	border-radius: 20px;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	color: #1f1f1f;
	cursor: pointer;
	font-family: 'Roboto', arial, sans-serif;
	font-size: 14px;
	height: 40px;
	letter-spacing: 0.25px;
	outline: none;
	overflow: hidden;
	padding: 0 12px;
	position: relative;
	text-align: center;
	-webkit-transition: background-color .218s, border-color .218s, box-shadow .218s;
	transition: background-color .218s, border-color .218s, box-shadow .218s;
	vertical-align: middle;
	white-space: nowrap;
	width: auto;
	max-width: 400px;
	min-width: min-content;
}

.gsi-material-button .gsi-material-button-icon {
	height: 20px;
	margin-right: 12px;
	min-width: 20px;
	width: 20px;
}

.gsi-material-button .gsi-material-button-content-wrapper {
	-webkit-align-items: center;
	align-items: center;
	display: flex;
	-webkit-flex-direction: row;
	flex-direction: row;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	height: 100%;
	justify-content: space-between;
	position: relative;
	width: 100%;
}

.gsi-material-button .gsi-material-button-contents {
	-webkit-flex-grow: 1;
	flex-grow: 1;
	font-family: 'Roboto', arial, sans-serif;
	font-weight: 500;
	overflow: hidden;
	text-overflow: ellipsis;
	vertical-align: top;
}

.gsi-material-button .gsi-material-button-state {
	-webkit-transition: opacity .218s;
	transition: opacity .218s;
	bottom: 0;
	left: 0;
	opacity: 0;
	position: absolute;
	right: 0;
	top: 0;
}

.gsi-material-button:disabled {
	cursor: default;
	background-color: #ffffff61;
	border-color: #1f1f1f1f;
}

.gsi-material-button:disabled .gsi-material-button-contents {
	opacity: 38%;
}

.gsi-material-button:disabled .gsi-material-button-icon {
	opacity: 38%;
}

.gsi-material-button:not(:disabled):active .gsi-material-button-state,
.gsi-material-button:not(:disabled):focus .gsi-material-button-state {
	background-color: #303030;
	opacity: 12%;
}

.gsi-material-button:not(:disabled):hover {
	-webkit-box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
	box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
}

.gsi-material-button:not(:disabled):hover .gsi-material-button-state {
	background-color: #303030;
	opacity: 8%;
}


</style>